import CarnetsController from './carnets.controller';

export default {
    template: require('./carnets.html'),
    controller: CarnetsController
};
